/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AwsSsmJobGroup {
    getFixupPrototypeFunction() { return AwsSsmJobGroup.fixupPrototype; }

    static newInstance(model: Partial<AwsSsmJobGroup>): AwsSsmJobGroup {
        let obj = Object.assign(new AwsSsmJobGroup(), model);
        AwsSsmJobGroup.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AwsSsmJobGroup>): AwsSsmJobGroup {
        if (!model) return null;
        return AwsSsmJobGroup.newInstance(<AwsSsmJobGroup> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AwsSsmJobGroup) {
        if (!obj) return;

        models.AwsSsmJobGroup.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AwsSsmJobGroup): boolean {
        Object.setPrototypeOf(obj, AwsSsmJobGroup.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (typeof this.created_at === "string") {
            this.created_at = new Date(<string><any>this.created_at);
        }
        if (typeof this.updated_at === "string") {
            this.updated_at = new Date(<string><any>this.updated_at);
        }
    }

    /**
     * Id of the Group Executions
     */
    sysId: string;

    /**
     * Status of the Job Group
     */
    status: models.AwsSsmJobGroupStatus;

    /**
     * Document id from the ssm_docs collection
     */
    document_id: string;

    /**
     * Document version id from the ssm_docs_version collection
     */
    document_version: string;

    /**
     * Type of the document
     */
    document_type: models.AwsSsmJobGroupDocumentType;

    /**
     * The date when the job was fetched
     */
    created_at: Date;

    /**
     * Name of the user who executed the document
     */
    created_by: string;

    /**
     * Date when the document was last updated
     */
    updated_at: Date;

    /**
     * Name of the user who updated the execution
     */
    updated_by: string;

    /**
     * Service Now tracking id
     */
    change_id: string;

}
